import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import config from './RootConfig';
import constants from '../constants';

var $ = require('jquery');

const divs = [];

export default class TermsPage extends Component {

    constructor(props) {
        super(props);

        this.state = { divs: divs };
    }

    componentDidMount() {
        //console.log('componentDidMount...');

        window.scrollTo(0, 0);
    }

    render() {
        //console.log('render...');
        let pagecontent;

	if (window.location.hostname.indexOf(config.NJG) != -1) {
		pagecontent = (
<div class="box-full">
<h1>使用條款</h1>
<p>以下是 njg 使用條款，我們按照條款的規定，為您提供這項服務。要使用 njg 服務，請細讀條款。</p>
<h3 style={{ "paddingTop" : "0px" }}>1. 同意接受條款</h3>
<p>歡迎您使用 njg 的服務。以下是 njg 使用條款 (下稱「條款」)，我們按照條款的規定，為您提供這項服務。我們會不時修訂條款而無需特意通知您。修訂的條款將於公開張貼當日起即時生效，並取代舊有的條款。當您使用特定的 njg 服務時，>我們雙方均需要遵守為特定服務而公開張貼 (並不時重新張貼)的指引及規則。這些指引和規則均構成本使用條款的一部分。</p>
<h3>2. 您的註冊義務</h3>
<p>為了能使用 njg 服務，您同意以下事項：
</p><ul>
<li>依 njg 服務註冊表之提示提供您本人正確、精確、最新及完整的資料（以下簡稱「登記資料」）；</li>
<li>維持及更新「登記資料」，確保其為正確、精確、最新及完整。若您提供任何錯誤、不實、過時、不完整或有誤導成分的資料，或者 njg 有充份的理由懷疑之前資料為錯誤、不實、過時、不完整或有誤導成分的資料， njg 有權暫停或終止您的帳號
，並拒絕您于現在和未來使用本服務之全部或一部。</li>
</ul><p></p>
<h3>3. 私隱</h3>
<p>由 njg 保存並與你有關的「登記資料」及其它相關資料均受到個人資料條例和本公司「私隱條款」之規管。請到「私隱條款」閱讀全文。</p>
<h3>4. 會員帳號、密碼及安全</h3>
<p>完成 njg 服務的會員登記程式之後，您有責任維持密碼及帳號的機密安全。利用該密碼及帳號所進行的一切行動，您將負上完全的責任。您同意以下事項：
</p><ul>
<li>您的密碼或帳號遭到未獲授權的使用，或者其他任何安全問題發生時，您需要即時通知 njg ；</li>
<li>每次聯機完畢，均結束您的帳號使用。您未能遵守本項規定所衍生之任何損失或損害， njg 將不予負責。</li>
</ul>
<h3 style={{ "paddingTop" : "38px" }}>5. 國際使用之特別警告</h3>
<p>您瞭解網際網路的無國界性，同意遵守當地所有相關規定之網上行為及可接受「內容」之法規。您特別同意遵守關於從您居住的國家或地區輸出技術性或個人資料所有相關法律。</p>
<h3>6. 會員行為</h3>
<p>您瞭解一切的資訊、文字、軟體、音樂、音訊、照片、圖形、視訊或其他資料（以下簡稱「內容」），無論為公開張貼或私下傳送，均為「內容」提供 者之責任。易言之，您，而非 njg ，將對經由 njg 上載、張貼、發送電子郵件或傳送之「內容」
負完全的責任。 njg 無法控制經由 njg 而張貼之「內容」，因此不保證「內容」之正確性、完整性或品質。您瞭解使用本服務時，可能會接觸到令人不快、不適當、令人厭惡之「內容」。 在任何情況下， njg 均不會對任何「內容」負責，包含但不
限於任何「內容」之任何錯誤或遺漏，以及經由 njg 張貼、發送電子郵件或傳送而衍生之任何損失或損害。</p>
<h3>7. 禁止用途</h3>
<p>您同意不將 njg 服務作以下用途：</p>
<ul>
<li>上載、張貼、發送電子郵件或傳送任何有違香港特別行政區法律、有害、脅迫、濫用、騷擾、侵害、中傷、粗俗、猥褻、誹謗、侵害他人私隱、種族歧視的或道德上令人不快的「內容」；</li>
<li>冒充任何人或機構，或以虛偽不實的方式陳述或謊稱與任何人或機構之關係；</li>
<li>偽造標題或以其他方式操控識別資料，以偽裝經由 njg 傳送之任何「內容」之來源；</li>
<li>將侵害任何人之任何專利、商標、營業機密、版權或其他專屬權利之「內容」加以上載、張貼、發送電子郵件或以其他方式傳送；</li>
<li>將任何「垃圾郵件」、「濫發信件」、「連鎖信件」、「直銷」或其他任何形式的勸誘資料加以上載、張貼、發送電子郵件或以其他方式傳送。不過此條款仍然受所有適用於本範疇的指引和規則所規管；</li>
<li>將設計目的在於干擾、破壞或限制任何電腦軟體、硬體或通訊設備功能之軟體病毒，包括但不限於「木馬」病毒（Trojan Horses）、蠕蟲（worms）、「計時炸彈」(time bombs) 或刪除蠅（cancelbots）以下簡稱「病毒」)，或其他電腦代碼、檔案和程
式之任何資料，加以上載、張貼、發送電子郵件或以其他方式傳送；</li>
<li>破壞正常的對話流程、造成螢幕快速移動，或使 njg 服務其他使用者無法打字，或對其他使用者參加即時交流的能力產生負面影響；</li>
<li>干擾或破壞 njg 服務或與 njg 服務相聯機之伺服器和網路，或不遵守於 njg 服務聯機網路之規定、程式、政策或規範；</li>
<li>搜集和儲存其他使用者之個人資料。如果有關個人資料得到正確儲存，並根據有關的個人資料保障條例而使用，則不在此列。</li>
</ul>
<p>您瞭解 njg 並未針對「內容」事先加以審查，但 njg 及其指定人有權（但無義務）依其自行之考量，拒絕和移除可經由 njg 服務提供之任何「內容」。在不限制前開規定之前提下， njg 及其指定人有權將違反本使用條款和令人厭惡之任何「>內容」加以移除。您使用任何「內容」時， 包括依賴前開「內容」之正確性、完整性或實用性之情形，您同意必須自行加以評估並承擔所有風險。因此，您同意您不得依賴 njg 創造或接受之任何 「內容」。</p>
<p>您瞭解並同意， njg 依據法律或規定的要求，或基於誠信為了以下目的之合理必要範圍內，認定必須將「內容」加以保存或揭露時，得加以保存及揭露：</p>
<ul>
<li>遵守法律程式；</li>
<li>執行本使用條款；</li>
<li>回應任何「內容」侵害第三人權利之主張；</li>
<li>保護 njg 、其使用者及公眾之權利、財產或個人安全。</li>
</ul>
<p>您瞭解本服務之技術處理及傳送，包含您「內容」，可能經由各個網路加以傳送，且為了符合及配合聯機網路或裝置之技術要求而進行改變。</p>
<h3>8. 連結</h3>
<p>njg 服務或第三人可提供與其他全球資訊網上之網站或資源之連結。由於 njg 無法控制前開網站及資源，您瞭解並同意，外部網站或資源是否可供利用， njg 不予負責，存在或源於前開網站或資源之任何「內容」、廣告、產品或其他資料，不代>表 njg 對其贊同， njg 亦不予負責。您進一步同意，因使用或信賴存在或經由前開任何網站或資源之任何「內容」、商品或服務所生或據稱所生之任何損害或損失， njg 不負任何直接或間接之責任。</p>
<h3>9. 服務之修改</h3>
<p>njg 有權於任何時間暫時或永久修改或終止 njg 服務（或其任何部分），無論其通知與否。 njg 服務任何修改、暫停或終止，您同意 njg 對您和任何第三人均不承擔責任。</p>
<h3>10. 終止</h3>
<p>您同意 njg 得基於其自行之考量，因任何理由，包含但不限於缺乏使用，或 njg 認為您已經違反本使用條款的明文規定及精神，終止您的密碼、帳號（或其任何部分）或 njg 服務之使用，並將 njg 服務內任何「內容」加以移除並刪除。 njg 無論有否通知你，都可以依其 自行之考量隨時終止 njg 服務或其任何部分。您同意依 njg 使用條款任何規定提供之 njg 服務，無需事先通知你即可暫停或終止，您承認並同意， njg 得立即關閉或刪除您的帳號及您帳號中所有相關資料及檔案>，及/或禁止前開檔案和 njg 服務之使用。此外，您同意若你 被暫停或終止進入 njg 服務，或你的帳戶或有關的資料和檔案被凍結或刪除時， njg 對您或任何第三人均不承擔責任。</p>
<h3>11. 一般條款</h3>
<p>njg 使用條款構成您與 njg 之全部合意，並規範您對於 njg 服務之使用。您使用相關服務、第三方內容或軟體時，亦應符合適用之 額外條款及條件。本使用條款及您與 njg 之關係，均受到香港特別行政區的法律所管轄，不適用其涉外法律原>則。您與 njg 均同意接受法院之個人及專屬管轄。 njg 未行使或執行本使用條款任何權利或規定，不構成前開權利或權利之拋棄。倘本使用條款任何規定經管轄法院認定無效，當事人依 然同意法院應努力使前開規定反映之當事人意向具備效力，且本>使用條款其他規定仍應保有完整的效力及效果。您同意無論任何法令或法律是否有其他規定，本服務之使用或本使用條款所衍生或相關之任何主張或訴訟原因，應於前開主張或訴訟原因發生後一個月內提出，否則永遠不得提出。
本使用條款之標題僅供方便而設，不具任何法律或契約效果。</p>
<h3>12. 違約</h3>
<p>倘發現任何違反本使用條款之事情，請即通知我們。</p>
</div>
		)
	}
	else {
		pagecontent = (
<div class="box-full">
<h1>使用條款</h1>
<p>以下是 minibean 使用條款，我們按照條款的規定，為您提供這項服務。要使用 minibean 服務，請細讀條款。</p>
<h3 style={{ "paddingTop" : "0px" }}>1. 同意接受條款</h3>
<p>歡迎您使用 minibean 的服務。以下是 minibean 使用條款 (下稱「條款」)，我們按照條款的規定，為您提供這項服務。我們會不時修訂條款而無需特意通知您。修訂的條款將於公開張貼當日起即時生效，並取代舊有的條款。當您使用特定的 minibean 服務時，>我們雙方均需要遵守為特定服務而公開張貼 (並不時重新張貼)的指引及規則。這些指引和規則均構成本使用條款的一部分。</p>
<h3>2. 您的註冊義務</h3>
<p>為了能使用 minibean 服務，您同意以下事項：
</p><ul>
<li>依 minibean 服務註冊表之提示提供您本人正確、精確、最新及完整的資料（以下簡稱「登記資料」）；</li>
<li>維持及更新「登記資料」，確保其為正確、精確、最新及完整。若您提供任何錯誤、不實、過時、不完整或有誤導成分的資料，或者 minibean 有充份的理由懷疑之前資料為錯誤、不實、過時、不完整或有誤導成分的資料， minibean 有權暫停或終止您的帳號
，並拒絕您于現在和未來使用本服務之全部或一部。</li>
</ul><p></p>
<h3>3. 私隱</h3>
<p>由 minibean 保存並與你有關的「登記資料」及其它相關資料均受到個人資料條例和本公司「私隱條款」之規管。請到「私隱條款」閱讀全文。</p>
<h3>4. 會員帳號、密碼及安全</h3>
<p>完成 minibean 服務的會員登記程式之後，您有責任維持密碼及帳號的機密安全。利用該密碼及帳號所進行的一切行動，您將負上完全的責任。您同意以下事項：
</p><ul>
<li>您的密碼或帳號遭到未獲授權的使用，或者其他任何安全問題發生時，您需要即時通知 minibean ；</li>
<li>每次聯機完畢，均結束您的帳號使用。您未能遵守本項規定所衍生之任何損失或損害， minibean 將不予負責。</li>
</ul>
<h3 style={{ "paddingTop" : "38px" }}>5. 國際使用之特別警告</h3>
<p>您瞭解網際網路的無國界性，同意遵守當地所有相關規定之網上行為及可接受「內容」之法規。您特別同意遵守關於從您居住的國家或地區輸出技術性或個人資料所有相關法律。</p>
<h3>6. 會員行為</h3>
<p>您瞭解一切的資訊、文字、軟體、音樂、音訊、照片、圖形、視訊或其他資料（以下簡稱「內容」），無論為公開張貼或私下傳送，均為「內容」提供 者之責任。易言之，您，而非 minibean ，將對經由 minibean 上載、張貼、發送電子郵件或傳送之「內容」
負完全的責任。 minibean 無法控制經由 minibean 而張貼之「內容」，因此不保證「內容」之正確性、完整性或品質。您瞭解使用本服務時，可能會接觸到令人不快、不適當、令人厭惡之「內容」。 在任何情況下， minibean 均不會對任何「內容」負責，包含但不
限於任何「內容」之任何錯誤或遺漏，以及經由 minibean 張貼、發送電子郵件或傳送而衍生之任何損失或損害。</p>
<h3>7. 禁止用途</h3>
<p>您同意不將 minibean 服務作以下用途：</p>
<ul>
<li>上載、張貼、發送電子郵件或傳送任何有違香港特別行政區法律、有害、脅迫、濫用、騷擾、侵害、中傷、粗俗、猥褻、誹謗、侵害他人私隱、種族歧視的或道德上令人不快的「內容」；</li>
<li>冒充任何人或機構，或以虛偽不實的方式陳述或謊稱與任何人或機構之關係；</li>
<li>偽造標題或以其他方式操控識別資料，以偽裝經由 minibean 傳送之任何「內容」之來源；</li>
<li>將侵害任何人之任何專利、商標、營業機密、版權或其他專屬權利之「內容」加以上載、張貼、發送電子郵件或以其他方式傳送；</li>
<li>將任何「垃圾郵件」、「濫發信件」、「連鎖信件」、「直銷」或其他任何形式的勸誘資料加以上載、張貼、發送電子郵件或以其他方式傳送。不過此條款仍然受所有適用於本範疇的指引和規則所規管；</li>
<li>將設計目的在於干擾、破壞或限制任何電腦軟體、硬體或通訊設備功能之軟體病毒，包括但不限於「木馬」病毒（Trojan Horses）、蠕蟲（worms）、「計時炸彈」(time bombs) 或刪除蠅（cancelbots）以下簡稱「病毒」)，或其他電腦代碼、檔案和程
式之任何資料，加以上載、張貼、發送電子郵件或以其他方式傳送；</li>
<li>破壞正常的對話流程、造成螢幕快速移動，或使 minibean 服務其他使用者無法打字，或對其他使用者參加即時交流的能力產生負面影響；</li>
<li>干擾或破壞 minibean 服務或與 minibean 服務相聯機之伺服器和網路，或不遵守於 minibean 服務聯機網路之規定、程式、政策或規範；</li>
<li>搜集和儲存其他使用者之個人資料。如果有關個人資料得到正確儲存，並根據有關的個人資料保障條例而使用，則不在此列。</li>
</ul>
<p>您瞭解 minibean 並未針對「內容」事先加以審查，但 minibean 及其指定人有權（但無義務）依其自行之考量，拒絕和移除可經由 minibean 服務提供之任何「內容」。在不限制前開規定之前提下， minibean 及其指定人有權將違反本使用條款和令人厭惡之任何「>內容」加以移除。您使用任何「內容」時， 包括依賴前開「內容」之正確性、完整性或實用性之情形，您同意必須自行加以評估並承擔所有風險。因此，您同意您不得依賴 minibean 創造或接受之任何 「內容」。</p>
<p>您瞭解並同意， minibean 依據法律或規定的要求，或基於誠信為了以下目的之合理必要範圍內，認定必須將「內容」加以保存或揭露時，得加以保存及揭露：</p>
<ul>
<li>遵守法律程式；</li>
<li>執行本使用條款；</li>
<li>回應任何「內容」侵害第三人權利之主張；</li>
<li>保護 minibean 、其使用者及公眾之權利、財產或個人安全。</li>
</ul>
<p>您瞭解本服務之技術處理及傳送，包含您「內容」，可能經由各個網路加以傳送，且為了符合及配合聯機網路或裝置之技術要求而進行改變。</p>
<h3>8. 連結</h3>
<p>minibean 服務或第三人可提供與其他全球資訊網上之網站或資源之連結。由於 minibean 無法控制前開網站及資源，您瞭解並同意，外部網站或資源是否可供利用， minibean 不予負責，存在或源於前開網站或資源之任何「內容」、廣告、產品或其他資料，不代>表 minibean 對其贊同， minibean 亦不予負責。您進一步同意，因使用或信賴存在或經由前開任何網站或資源之任何「內容」、商品或服務所生或據稱所生之任何損害或損失， minibean 不負任何直接或間接之責任。</p>
<h3>9. 服務之修改</h3>
<p>minibean 有權於任何時間暫時或永久修改或終止 minibean 服務（或其任何部分），無論其通知與否。 minibean 服務任何修改、暫停或終止，您同意 minibean 對您和任何第三人均不承擔責任。</p>
<h3>10. 終止</h3>
<p>您同意 minibean 得基於其自行之考量，因任何理由，包含但不限於缺乏使用，或 minibean 認為您已經違反本使用條款的明文規定及精神，終止您的密碼、帳號（或其任何部分）或 minibean 服務之使用，並將 minibean 服務內任何「內容」加以移除並刪除。 minibean 無論有否通知你，都可以依其 自行之考量隨時終止 minibean 服務或其任何部分。您同意依 minibean 使用條款任何規定提供之 minibean 服務，無需事先通知你即可暫停或終止，您承認並同意， minibean 得立即關閉或刪除您的帳號及您帳號中所有相關資料及檔案>，及/或禁止前開檔案和 minibean 服務之使用。此外，您同意若你 被暫停或終止進入 minibean 服務，或你的帳戶或有關的資料和檔案被凍結或刪除時， minibean 對您或任何第三人均不承擔責任。</p>
<h3>11. 一般條款</h3>
<p>minibean 使用條款構成您與 minibean 之全部合意，並規範您對於 minibean 服務之使用。您使用相關服務、第三方內容或軟體時，亦應符合適用之 額外條款及條件。本使用條款及您與 minibean 之關係，均受到香港特別行政區的法律所管轄，不適用其涉外法律原>則。您與 minibean 均同意接受法院之個人及專屬管轄。 minibean 未行使或執行本使用條款任何權利或規定，不構成前開權利或權利之拋棄。倘本使用條款任何規定經管轄法院認定無效，當事人依 然同意法院應努力使前開規定反映之當事人意向具備效力，且本>使用條款其他規定仍應保有完整的效力及效果。您同意無論任何法令或法律是否有其他規定，本服務之使用或本使用條款所衍生或相關之任何主張或訴訟原因，應於前開主張或訴訟原因發生後一個月內提出，否則永遠不得提出。
本使用條款之標題僅供方便而設，不具任何法律或契約效果。</p>
<h3>12. 違約</h3>
<p>倘發現任何違反本使用條款之事情，請即通知我們。</p>
</div>
		)
	}
	return (
            <div style={{ "marginTop": "50px" }}>
                <div className="col-md-1">
                </div>
                <div className="col-md-10">
                    <div className="themeA-container">
                        <div className="row">
                            <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12" style={{ "marginTop": "5px" }}>
                                <div className="general-box" style={{ "minHeight": "300px" }}>
					{pagecontent}
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12" style={{ "marginTop": "5px" }}>
                                {/*
                                <div id="articles-slider" className="general-box" style={{ "height": "180px" }}>

                                </div>
                                <div id="articles-slider" className="general-box" style={{ "height": "180px" }}>

                                </div>
                                */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-1">
                </div>
            </div >
        )
    }
}





// WEBPACK FOOTER //
// ./src/containers/TermsPage.js